module.exports = __webpack_public_path__ + "img/service1.850bee03.webp";